module.exports = __webpack_public_path__ + "img/partners16.1755464e.png";